import { render } from "./HistoriqueLecture.vue?vue&type=template&id=27189f80&scoped=true&ts=true"
import script from "./HistoriqueLecture.vue?vue&type=script&lang=ts"
export * from "./HistoriqueLecture.vue?vue&type=script&lang=ts"

import "./HistoriqueLecture.vue?vue&type=style&index=0&id=27189f80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27189f80"]])

export default __exports__